import { render, staticRenderFns } from "./contestManage.vue?vue&type=template&id=0edb0b47&scoped=true"
import script from "./contestManage.vue?vue&type=script&lang=js"
export * from "./contestManage.vue?vue&type=script&lang=js"
import style0 from "./contestManage.vue?vue&type=style&index=0&id=0edb0b47&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb0b47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edb0b47')) {
      api.createRecord('0edb0b47', component.options)
    } else {
      api.reload('0edb0b47', component.options)
    }
    module.hot.accept("./contestManage.vue?vue&type=template&id=0edb0b47&scoped=true", function () {
      api.rerender('0edb0b47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operation/contestManage.vue"
export default component.exports